export const WIDTH = 1920;
export const HEIGHT = 1080;
export const CELL_SIZE = 75;
export const PIECE_RADIUS = (CELL_SIZE / 2) * 0.875;

export const BOARD_WIDTH = 6;
export const BOARD_HEIGHT = 12;
export const INIT_FILL_HEIGHT = 0;

export const TEXT_FONT = "Courier New";

export const theme = {
  colors: {
    primary: "#ddd",
    background: "#080808",
    muted: "#aaa",
  },
};
